/**
 * Overview “Create event” hands off to the same modals as Classes / PT / Facilities
 * by navigating with ?create=class|pt|facility; each tab consumes the param on mount.
 */
export const SCHEDULING_BASE_PATH = "/coaching-portal/scheduling";

const TAB_BY_KIND = {
  class: "classes",
  pt: "pt-sessions",
  facility: "facilities",
};

/**
 * Full navigation to the tab that owns the create modal (same as sidebar links).
 * @param {"class"|"pt"|"facility"} kind
 */
export function navigateToSchedulingTabCreate(kind) {
  const tab = TAB_BY_KIND[kind];
  if (!tab || typeof window === "undefined") return;
  const url = `${SCHEDULING_BASE_PATH}?tab=${encodeURIComponent(tab)}&create=${encodeURIComponent(kind)}`;
  window.location.assign(url);
}

/**
 * If the URL asks to open the create modal for this tab, strip `create` and return true.
 * Call once on mount from SchedulingClasses / SchedulingPtSessions / SchedulingFacilities.
 * @param {"class"|"pt"|"facility"} expectedKind
 */
export function consumeSchedulingCreateIntent(expectedKind) {
  if (typeof window === "undefined") return false;
  const sp = new URLSearchParams(window.location.search);
  if (sp.get("create") !== expectedKind) return false;
  sp.delete("create");
  const qs = sp.toString();
  const next = `${window.location.pathname}${qs ? `?${qs}` : ""}${window.location.hash || ""}`;
  window.history.replaceState({}, "", next);
  return true;
}

/**
 * Navigate to the owner tab and ask it to open the edit modal for the given record.
 * @param {"class"|"pt"|"facility"} kind
 * @param {string} id
 */
export function navigateToSchedulingTabEdit(kind, id) {
  const tab = TAB_BY_KIND[kind];
  if (!tab || !id || typeof window === "undefined") return;
  const url = `${SCHEDULING_BASE_PATH}?tab=${encodeURIComponent(tab)}&edit=${encodeURIComponent(kind)}&editId=${encodeURIComponent(id)}`;
  window.location.assign(url);
}

/**
 * If the URL asks to edit a record on this tab, strip `edit`/`editId` and return the id.
 * @param {"class"|"pt"|"facility"} expectedKind
 * @returns {string | null}
 */
export function consumeSchedulingEditIntent(expectedKind) {
  if (typeof window === "undefined") return null;
  const sp = new URLSearchParams(window.location.search);
  if (sp.get("edit") !== expectedKind) return null;
  const id = sp.get("editId");
  sp.delete("edit");
  sp.delete("editId");
  const qs = sp.toString();
  const next = `${window.location.pathname}${qs ? `?${qs}` : ""}${window.location.hash || ""}`;
  window.history.replaceState({}, "", next);
  return id ? String(id) : null;
}
